var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"outlined":"","single-line":"","dense":"","prepend-inner-icon":"mdi-magnify","label":"Pesquisar","hide-details":"","clearable":""},on:{"click:clear":function($event){return _vm.handleClear()}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }